import React from "react";
import TextInput from "../../sharedComponents/inputs/textInput";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import Lang from "../../../userPreferences/staticWords";
import Button from "../../sharedComponents/buttons/button";
import { useFormik } from "formik";
import FileInput from "../../sharedComponents/inputs/fileInput";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import DateInput from "../../sharedComponents/datesInputs/date";
const PageOne = ({ setPages, setPageOneData, pageOneData, dropdownLists }) => {
  const submit = (values) => {
    setPageOneData(values);
    nextRender();
  };

  const formik = useFormik(
    formikSetup(initialValues, pageOneData, validationSchema, "pageOne", submit)
  );
  const { errors, touched, handleSubmit, handleChange, setFieldValue, values } =
    formik;
  const nextRender = () => {
    setPages({ one: false, two: true, three: false });
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ display: "contents" }}>
        <div className="col-12   d-flex justify-content-md-center justify-content-between">
          <div className="col-md-4 col-6  mt-4">
            <TextInput
              name={"firstName"}
              value={values.firstName}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "firstName")}
              type={"text"}
              placeholder={Lang.firstName}
              containerStyle={"col-12  mt-4"}
            ></TextInput>
            <TextInput
              name={"lastName"}
              value={values.lastName}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "lastName")}
              type={"text"}
              placeholder={Lang.lastName}
              containerStyle={"col-12   mt-4"}
            ></TextInput>
          </div>
          <div className="col-4 mx-3  d-flex justify-content-center align-items-end">
            <FileInput
              iconPrefix={"far"}
              iconName={"user-circle"}
              name={"user-circle"}
              fileName={" "}
              src={values.photo}
              backgroundSize={95}
              backgroundColor={"#60606085"}
              size={95}
              uploaded={values.photo ? true : false}
              uploadedMessage={values.photo ? "تغيير" : ""}
              onChange={(e) => {
                setFieldValue("photo", e.target.files[0]);
              }}
              error={formikValidation(touched, errors, "photo")}
            />
          </div>
        </div>
        <DropDownList
          dataSource={dropdownLists.genders}
          value={values.gender}
          change={(e) => {
            setFieldValue("gender", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "gender")}
          placeholder={Lang.gender}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <DropDownList
          dataSource={dropdownLists.titles}
          value={values.title}
          change={(e) => {
            setFieldValue("title", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "title")}
          placeholder={Lang.jobTitle}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <div className="col-lg-9 col-md-10 col-12 justify-content-center d-flex">
          <TextInput
            name={"email"}
            value={values.email}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "email")}
            type={"email"}
            placeholder={Lang.mail}
            // iconName={"paperclip"}
            // iconSize={16}
            containerStyle={"col-lg-11 col-md-10 col-12 mt-4 p-0"}
          ></TextInput>
        </div>
        <TextInput
          type={"text"}
          value={values.phoneOne}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "phoneOne")}
          name={"phoneOne"}
          placeholder={Lang.phoneNumberOne}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></TextInput>
        <TextInput
          name={"phoneTwo"}
          value={values.phoneTwo}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "phoneTwo")}
          type={"text"}
          placeholder={Lang.phoneNumberTwo}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></TextInput>
        <DropDownList
          dataSource={dropdownLists.nationalities}
          value={values.nationality}
          change={(e) => {
            setFieldValue("nationality", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "nationality")}
          placeholder={Lang.nationality}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <div className="col-12 col-md-4 mx-3 mt-4">
          <DateInput
            value={values.brithDay}
            errorMessage={formikValidation(touched, errors, "brithDay")}
            name={"brithDay"}
            onChange={(e) => {
              setFieldValue("brithDay", e);
            }}
          />
        </div>
        <DropDownList
          dataSource={dropdownLists.countries}
          value={values.country}
          change={(e) => {
            setFieldValue("country", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "country")}
          type={"text"}
          placeholder={Lang.country}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
        <TextInput
          type={"text"}
          value={values.town}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "town")}
          name={"town"}
          placeholder={Lang.town}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></TextInput>
        <div className="col-lg-9 col-md-10 col-12 justify-content-center d-flex">
          <TextInput
            type={"text"}
            value={values.address}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "address")}
            name={"address"}
            placeholder={Lang.address}
            containerStyle={"col-lg-11 col-md-10 col-12 mt-4 p-0"}
          ></TextInput>
        </div>
        <Button
          type={"submit"}
          content={Lang.nextButton}
          containerStyle={"col-3 mx-3 my-3"}
        />
      </form>
    </>
  );
};

export default PageOne;
